'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDashboardBuilderTemplates, iconDashboardBuilderTemplatesTag } from '@ni/nimble-components/dist/esm/icons/dashboard-builder-templates';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDashboardBuilderTemplates };
export { iconDashboardBuilderTemplatesTag };
export const NimbleIconDashboardBuilderTemplates = wrap(IconDashboardBuilderTemplates);